<ul class="list-inline" *ngIf="filters">
  <li *ngFor="let filter of filters">
    <span class="text-success h4">
      <span class="material-icons">filter_list</span>{{ filter.property }}:
    </span>
    <span class="text-muted">{{ filter.value }}</span>
  </li>
</ul>
